import React from 'react';
import { HighestExamResultView } from '../../graphql/types.gen.ts';

export const getColorResult = (result: HighestExamResultView) => {
	switch (result) {
		case HighestExamResultView.Failed:
			return 'red-500';
		case HighestExamResultView.HalfSuccess:
			return 'green-300';
		case HighestExamResultView.FullSuccess:
			return 'green-500';
		default:
			return 'gray-300';
	}
};

export const TestItem = ({ item, drawTestById, closeDrawer }) => {
	return (
		<button
			className={`testItem ${getColorResult(item?.myHighestResult)}`}
			onClick={() => {
				drawTestById(item?.id);
				closeDrawer();
			}}
		>
			<span className="testItem__marker" aria-hidden="true">
				{item?.myHighestResult === HighestExamResultView.Failed && '✕'}
			</span>
		</button>
	);
};
